import { DataGrid } from '@/components/DataGrid/DataGrid';
import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-pro';

export const MetadataBulkDataGrid = <T extends GridValidRowModel & { id: string | number }>({
  columns,
  rows,
  rowCount,
  hideFooter = false,
}: {
  columns: GridColDef[];
  rows: T[];
  rowCount: number;
  hideFooter?: boolean;
}) => {
  return (
    <DataGrid
      sx={{
        height: '100%',
        borderRadius: '6px !important',
        '& .MuiDataGrid-cell': {
          lineHeight: 'unset !important',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
      }}
      columns={columns}
      rows={rows}
      rowCount={rowCount}
      pagination={false}
      disableVirtualization={false}
      hideFooter={hideFooter}
    />
  );
};
